import { styled } from "@mui/material";
import { Link } from "react-router-dom";

type HTMLImageProps = React.HTMLProps<HTMLImageElement>;

type Props = {
  caption?: string;
  showCaption?: boolean;
  data?: string;
  description?: string;
  href?: string;
  src: string;
  alt?: string;
  title?: string;
} & HTMLImageProps;

const StyledFigure = styled("figure")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  margin: 0,
  padding: 0,
  height: "100%",
  maxWidth: "100%",
  maxHeight: "100%",
});

const StyledCaption = styled("figcaption")(({ theme }) => ({
  fontSize: theme.typography.caption.fontSize,
  color: theme.palette.text.secondary,
}));

const WrappedImage = ({ href, ...restProps }: HTMLImageProps & { href?: string }) => {
  if (!href) return <img {...restProps} />;

  return (
    <Link to={href}>
      <img {...restProps} />
    </Link>
  );
};

export const Image = ({
  src,
  href,
  caption: captionFromProps,
  showCaption = true,
  description,
  title,
  alt,
  ...rest
}: Props) => {
  if (!src) return <span>No image found</span>;

  const prefix = src.includes("://") ? "" : import.meta.env.VITE_API_BASE_PATH;
  const srcWithBase = `${prefix}${src}`;

  const caption = captionFromProps || description || title || alt;
  let altProp = alt || title || description;
  if (!alt) {
    altProp = "Informatie alleen als afbeelding beschikbaar";
  }

  return (
    <StyledFigure>
      <WrappedImage
        src={srcWithBase}
        alt={altProp}
        href={href}
        style={{
          height: "100%",
          width: "100%",
          objectFit: "contain",
          marginInline: "auto",
        }}
        {...rest}
      />
      {showCaption && caption && <StyledCaption>{caption}</StyledCaption>}
    </StyledFigure>
  );
};

export default Image;
